<div class="aplayer-info">
  <slot name="info" />
  <slot name="lyric" />
  <slot name="controller" />
</div>



// WEBPACK FOOTER //
// ./src/components/Main/src/Main.html